<template>
  <div class="auto-reminders--content">
    <div class="auto-reminders--block">
      <div>
        <div class="input-block">
          <label for="remind_before">
            Напомнить клиенту о записи
            <hints :type="'text'" :title="'Напоминания клиенту о записи'">
            <div slot="text">
              <div v-if="enrollVal == 0">
                Если хотите добавить автонапоминание, то выберите время и
                сохраните запись. <br><br>
                Если у вас в настройках настроены автонапоминания только на e-mail, а у клиента в базе
                нет электронной почты, то автонапоминание создано не будет.<br><br>
                Если хотите изменить время, то выберите нужное и сохраните запись.
                Если же нужно отменить автонапоминание, то выберите "Не напоминать" и "Сохранить"
              </div>
              
              <div class="mrg-t-10">
                ! У записей в статусе "Выполнена" и "Отменена" автонапоминания не проставляются
              </div>
            </div>
          </hints>
          </label>
          <select
              name="remind_before"
              id="remind_before_setting"
              v-model="remindModel"
          >
            <option value="0">Не напоминать</option>
            <option value="1">За 1 час до начала записи</option>
            <option value="2">За 2 часа до начала записи</option>
            <option value="3">За 3 часа до начала записи</option>
            <option value="4">За 4 часа до начала записи</option>
            <option value="5">За 5 часов до начала записи</option>
            <option value="6">За 6 часов до начала записи</option>
            <option value="12">За 12 часов до начала записи</option>
            <option value="18">За 18 часов до начала записи</option>
            <option value="24">За 24 часа до начала записи</option>
          </select>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Hints from "@/components/Hints";
import Formatter from "@/components/libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "AutoReminders",
  components: {Hints},
  data() {
    return {
      remindModel: 0
    };
  },
  props: {
    remindSetting: Number,
    enrollVal: Number,
    isNewEnroll: Boolean
  },
  watch: {
    remindModel: function(val){
      this.emitResult(val);
    },
    remindComputedvalue: function(val){
      this.remindModel = val;
    }
  },
  computed: {
    remindComputedvalue(){
      let result = 0;
     
      if(this.isNewEnroll){
        result = this.remindSetting;
      }else{
        result = this.enrollVal;
      }
      return result;
    }
  },
  methods: {
    phpDatetimeToHuman(datetime){
      return formatter.datetimeToRus(datetime);
    },
    emitResult(val){
      this.$emit('change', val);
    }
  },
  created() {
    this.remindModel = this.remindComputedvalue;
    this.emitResult(this.remindModel);
  }
};
</script>

<style scoped lang="less">
.auto-reminders--content{
  .auto-reminders--block{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    margin: 15px 0;

    &>div{
      width: 100%;
    }
  }
}
</style>
